import { Link } from 'react-router-dom';
import SEO from '../components/SEO.js';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-surface-900 text-white flex items-center justify-center p-6">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <div className="text-center max-w-md">
        <div className="text-6xl font-bold text-brand-500 mb-4">404</div>
        <h1 className="text-2xl font-bold mb-2">Page Not Found</h1>
        <p className="text-surface-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="bg-brand-500 hover:bg-brand-600 text-white px-6 py-3 rounded-xl font-medium transition-colors"
          >
            Go Home
          </Link>
          <Link
            to="/browse"
            className="bg-surface-700 hover:bg-surface-600 text-white px-6 py-3 rounded-xl font-medium transition-colors"
          >
            Browse Cars
          </Link>
        </div>
      </div>
    </div>
  );
}
